(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dmv-bty"] && !Shopify.designMode) return;
  try {
    
(function(){function trace(root){if(root.dataset.traceReady)return;root.dataset.traceReady='true';if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;root.classList.add('has-blueprint-motion');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-traced');observer.unobserve(entry.target)}}),{threshold:.12});root.querySelectorAll('.bty-wrap').forEach(el=>observer.observe(el))}document.querySelectorAll('.dmv-bty').forEach(trace);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.dmv-bty').forEach(trace))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmv-entry"] && !Shopify.designMode) return;
  try {
    
(function(){let timer;let previousFocus;function close(root){root.querySelector('.yard-entry__screen').hidden=true;clearTimeout(timer);if(previousFocus&&previousFocus.isConnected)previousFocus.focus({preventScroll:true})}function play(root){if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;clearTimeout(timer);previousFocus=document.activeElement;const screen=root.querySelector('.yard-entry__screen');screen.hidden=true;void screen.offsetWidth;screen.hidden=false;root.querySelector('.yard-entry__skip').focus({preventScroll:true});timer=setTimeout(()=>close(root),3650)}document.addEventListener('click',e=>{const button=e.target.closest('.yard-entry__replay,.yard-entry__skip');if(!button)return;const root=button.closest('.yard-entry');if(button.matches('.yard-entry__replay'))play(root);else close(root)});document.addEventListener('keydown',e=>{if(e.key==='Escape'){const root=document.querySelector('.yard-entry');if(root)close(root)}});document.querySelectorAll('.yard-entry').forEach(play);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.yard-entry').forEach(play));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmv-rotation-intro"]) return;
  try {
    
(() => {
  const flight = document.querySelector('[data-rotation-flight]');
  if (!flight) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'dmv-rotation-entrance-v1';
  let timer;
  const finish = () => { flight.hidden = true; clearTimeout(timer); };
  const play = () => {
    if (reduced.matches) return;
    finish();
    requestAnimationFrame(() => {
      flight.hidden = false;
      timer = setTimeout(finish, 2450);
    });
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-flight-skip]')) finish();
    if (event.target.closest('[data-flight-replay]')) play();
  });
  reduced.addEventListener('change', event => { if (event.matches) finish(); });
  let seen = false;
  try { seen = sessionStorage.getItem(key) === 'seen'; sessionStorage.setItem(key, 'seen'); } catch (_) {}
  if (!seen) play();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmv-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){if(root.classList.contains('is-ready'))return;const pieces=Array.from(root.querySelectorAll('[data-piece]'));if(!pieces.length)return;let active=0;const storyDialog=root.querySelector('.legacy__story-dialog');root.querySelectorAll('[data-story-open]').forEach(button=>button.addEventListener('click',()=>{storyDialog.querySelector('[data-story-content]').replaceChildren(button.closest('[data-piece]').querySelector('template').content.cloneNode(true));storyDialog.showModal()}));storyDialog.querySelector('[data-story-close]').addEventListener('click',()=>storyDialog.close());storyDialog.addEventListener('click',e=>{if(e.target===storyDialog){const r=storyDialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)storyDialog.close()}});const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');const showcase=root.querySelector('.legacy__showcase');const count=root.querySelector('.legacy__count');const intro=root.querySelector('.legacy__intro');let revealTimer;function dismiss(){intro.hidden=true;clearTimeout(revealTimer)}function reveal(){if(reduced.matches)return;intro.hidden=true;void intro.offsetWidth;intro.hidden=false;revealTimer=setTimeout(dismiss,3650)}
function draw(){const mobile=window.matchMedia('(max-width: 599px)').matches;pieces.forEach((piece,i)=>{let d=(i-active+pieces.length)%pieces.length;if(d>pieces.length/2)d-=pieces.length;const isActive=d===0;piece.toggleAttribute('data-active',isActive);const ad=Math.abs(d);piece.style.setProperty('--x',`${d*(mobile?195:245)}px`);piece.style.setProperty('--y',`${ad===1?36:ad===2?0:0}px`);piece.style.setProperty('--scale',isActive?'1':ad===1?'.68':'.44');piece.style.setProperty('--rotate',`${d*7}deg`);piece.style.setProperty('--opacity',isActive?'1':ad===1?'.85':'.5');piece.style.setProperty('--z',5-ad);piece.setAttribute('aria-hidden',String(!isActive));piece.inert=!isActive;});count.textContent=`${String(active+1).padStart(2,'0')} / ${String(pieces.length).padStart(2,'0')}`;showcase.style.setProperty('--tilt','0deg')}
function move(dir){active=(active+dir+pieces.length)%pieces.length;draw()}
root.querySelector('[data-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-next]').addEventListener('click',()=>move(1));showcase.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});let startX=null;showcase.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')startX=e.clientX});showcase.addEventListener('pointerup',e=>{if(startX!==null&&Math.abs(e.clientX-startX)>45)move(e.clientX<startX?1:-1);startX=null});showcase.addEventListener('pointercancel',()=>startX=null);showcase.addEventListener('pointermove',e=>{if(e.pointerType==='mouse'&&!reduced.matches&&!root.querySelector('.legacy__pause').checked){const r=showcase.getBoundingClientRect();showcase.style.setProperty('--tilt',`${((e.clientX-r.left)/r.width-.5)*12}deg`)}});showcase.addEventListener('pointerleave',()=>showcase.style.setProperty('--tilt','0deg'));root.querySelector('.legacy__pause').addEventListener('change',()=>showcase.style.setProperty('--tilt','0deg'));root.querySelector('.legacy__skip').addEventListener('click',dismiss);root.querySelector('.legacy__replay').addEventListener('click',reveal);window.addEventListener('resize',draw);root.classList.add('is-ready');draw();if(root.dataset.introEnabled!=='false')reveal(); }
document.querySelectorAll('.legacy').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.legacy').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmv-watch"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('.yard-watch__play');if(!button)return;const media=button.closest('.yard-watch__media');const template=media.querySelector('template');if(!template)return;const frame=template.content.querySelector('iframe').cloneNode(true);media.replaceChildren(frame);frame.focus();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
